import {
  APIFieldAttributes,
  APIModelAttributes,
  ArdoqId,
} from '@ardoq/api-types';
import { modelOperations } from '@ardoq/core';
import { ModelTypes } from '@ardoq/data-model';

export const getModelTypeDictionaryKey = (model: ArdoqId, typeId: string) =>
  `${model}-${typeId}`;

export const toModelTypes = (
  modelList: APIModelAttributes[]
): Record<ArdoqId, ModelTypes> =>
  Object.fromEntries(
    modelList.map(model => [model._id, modelOperations.getModelTypes(model)])
  );

const getComponentTypesOfField = (
  field: APIFieldAttributes,
  modelTypes: Record<ArdoqId, ModelTypes>
) => {
  if (field.global) {
    return modelTypes[field.model]?.componentTypes || [];
  }
  return field.componentType || [];
};

const getReferenceTypesOfField = (
  field: APIFieldAttributes,
  modelTypes: Record<ArdoqId, ModelTypes>
) => {
  if (field.globalref) {
    return modelTypes[field.model]?.referenceTypes || [];
  }
  return field.referenceType || [];
};

export const toModelTypeDictionary = (
  fieldList: APIFieldAttributes[],
  modelTypes: Record<ArdoqId, ModelTypes>
) => {
  return fieldList.reduce<{
    [ArdoqId: string]: {
      [TypeId: string]: APIFieldAttributes;
    };
  }>((dictionary, field) => {
    const { model, name } = field;
    const componentTypes = getComponentTypesOfField(field, modelTypes);
    const referenceTypes = getReferenceTypesOfField(field, modelTypes);
    [...componentTypes, ...referenceTypes].forEach(typeId => {
      const key = getModelTypeDictionaryKey(model, typeId);
      if (!(key in dictionary)) {
        dictionary[key] = {};
      }
      dictionary[key][name] = field;
    });
    return dictionary;
  }, {});
};
